/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Industry
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns list of unique industries.
 * @summary Industries
 */
export const industries = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<Industry[]>(
      {url: `/securities/classification/industries`, method: 'GET', signal
    },
      options);
    }




export const getIndustriesQueryKey = () => {
    return [
    `/securities/classification/industries`
    ] as const;
    }


export const getIndustriesQueryOptions = <TData = Awaited<ReturnType<typeof industries>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof industries>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getIndustriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof industries>>> = ({ signal }) => industries(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof industries>>, TError, TData> & { queryKey: QueryKey }
}

export type IndustriesQueryResult = NonNullable<Awaited<ReturnType<typeof industries>>>
export type IndustriesQueryError = unknown


/**
 * @summary Industries
 */

export function useIndustries<TData = Awaited<ReturnType<typeof industries>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof industries>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getIndustriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






